export const GET_USER_ROLES_START = 'GET_USER_ROLES_START';
export const GET_USER_ROLES_END = 'GET_USER_ROLES_END';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_FAILURE = 'GET_USER_ROLES_FAILURE';
